import React from "react"
import ComponentWrapper from "../components/wrapper"
import BackgroundImage from "gatsby-background-image"
import ScrollAnimation from "../helpers/scrollAnimations"

const BasicQuote = ({reverseZindex, quote, attribute, quoteSize, backgroundImage}) => {
    if (backgroundImage) {
        return (
            <div className="basic-quote--wrapper">
                <BackgroundImage
                    Tag="div"
                    fluid={backgroundImage.localFile.childImageSharp.fluid}
                    className="basic-quote--background"
                    style={{'position':'absolute', 'height': '100%', 'width' : '100%'}}
                >
                    <ScrollAnimation zIndex={reverseZindex}>
                        <div className={`basic-quote basic-quote--${quoteSize}`}>
                            <h2 className={quoteSize}>{quote}</h2>
                            {attribute &&
                                    <div className="attribution">{attribute}</div>
                                }
                        </div>
                    </ScrollAnimation>
                </BackgroundImage>
            </div>
        )
    } else {
        return (
            <ComponentWrapper>
                <ScrollAnimation zIndex={reverseZindex}>
                    <div className={`basic-quote basic-quote--${quoteSize}`}>
                        <h2 className={quoteSize}>{quote}</h2>
                        {attribute &&
                            <div className="attribution">{attribute}</div>
                        }
                    </div>
                </ScrollAnimation>
            </ComponentWrapper>
        )
    }
    
}

export default BasicQuote